var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('v-icon',{staticClass:"mr-2",attrs:{"color":"primary","size":"48"}},[_vm._v("mdi-file-document-outline")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }